import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var TimeUnit = /*#__PURE__*/function () {
  function TimeUnit() {
    _classCallCheck(this, TimeUnit);
  }

  _createClass(TimeUnit, null, [{
    key: "isMinute",
    value: function isMinute(unit) {
      if (!unit) return false;
      var normalized = unit.toLowerCase();
      return normalized === TimeUnit.Minute || normalized === TimeUnit.Min;
    }
  }, {
    key: "isSecond",
    value: function isSecond(unit) {
      if (!unit) return true;
      var normalized = unit.toLowerCase();
      return normalized === TimeUnit.Second || normalized === TimeUnit.Sec;
    }
  }, {
    key: "toTotalSeconds",
    value: function toTotalSeconds(value, unit) {
      if (value === undefined || value === null) return 0;

      if (TimeUnit.isMinute(unit)) {
        return value * 60;
      }

      return value;
    }
  }, {
    key: "formatDisplayTime",
    value: function formatDisplayTime(totalSeconds) {
      if (!totalSeconds || totalSeconds < 0) return '00:00';
      var hours = Math.floor(totalSeconds / 3600);
      var mins = Math.floor(totalSeconds % 3600 / 60);
      var secs = Math.floor(totalSeconds % 60);
      var minsStr = mins < 10 ? "0".concat(mins) : "".concat(mins);
      var secsStr = secs < 10 ? "0".concat(secs) : "".concat(secs);

      if (hours > 0) {
        var hoursStr = hours < 10 ? "0".concat(hours) : "".concat(hours);
        return "".concat(hoursStr, ":").concat(minsStr, ":").concat(secsStr);
      }

      return "".concat(minsStr, ":").concat(secsStr);
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(value, unit) {
      if (value === undefined || value === null) return '00:00';
      var totalSeconds = TimeUnit.toTotalSeconds(value, unit);
      return TimeUnit.formatDisplayTime(totalSeconds);
    }
  }, {
    key: "formatTimer",
    value: function formatTimer(totalSeconds) {
      return TimeUnit.formatDisplayTime(totalSeconds);
    }
  }]);

  return TimeUnit;
}();

_defineProperty(TimeUnit, "Second", 'second');

_defineProperty(TimeUnit, "Minute", 'minute');

_defineProperty(TimeUnit, "Sec", 'sec');

_defineProperty(TimeUnit, "Min", 'min');